import { DocumentTextIcon, ArrowDownIcon } from '@heroicons/react/24/outline'

import { DocumentSigningStatus } from '../../../../lib/db/db.types'
import { PdfDisplay } from './PdfDisplay'

export function DocumentSigned({
  status,
  originalStorageFileUrl,
  signedStorageRef,
  signedStorageFileUrl,
}: {
  status: Extract<
    DocumentSigningStatus,
    'signing-complete' | 'signed' | 'error'
  >
  originalStorageRef?: string | null
  originalStorageFileUrl?: string | null
  signedStorageRef?: string | null
  signedStorageFileUrl?: string | null
}) {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border p-4 space-y-4">
        {status === 'signing-complete' ? (
          <div className="text-sm text-gray-600">
            Your document has been signed and is being processed. The signed
            copy will be available shortly.
          </div>
        ) : status === 'signed' ? (
          <div className="text-sm text-gray-600">
            Your document has been successfully signed and is ready for
            download.
          </div>
        ) : (
          <div className="text-sm text-red-600">
            There was an error signing your document.
          </div>
        )}

        <div className="space-y-2">
          <a
            href={originalStorageFileUrl ?? ''}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <DocumentTextIcon className="mr-2 h-4 w-4" />
            Download Original Document
          </a>

          {status === 'signed' && signedStorageFileUrl && (
            <a
              href={signedStorageFileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <ArrowDownIcon className="mr-2 h-4 w-4" />
              Download Signed Document
            </a>
          )}
        </div>
      </div>

      {status === 'signed' && !!signedStorageRef && (
        <div className="rounded-lg border p-4 space-y-4">
          <div className="text-sm text-gray-600">
            <PdfDisplay
              storageRef={signedStorageRef}
              scale={1}
              blocks={[]}
              readOnly
            />
          </div>
        </div>
      )}
    </div>
  )
}
